// extracted by mini-css-extract-plugin
export default {"container":"creditRiskScore_container__i4u1c","value":"creditRiskScore_value__llcaB"};